import { InventoryHint } from './InventoryHint';
import { InventoryMapButton } from './InventoryMap';
import type { GuideItem } from '../../shared/guide';
import { blockColor } from '../nbt/blockColor';
import { blockLabel } from '../nbt/blockLabel';
import { RubyText } from '../guide/ruby';

interface ItemChecklistProps {
  items: GuideItem[];
  checks: Record<string, boolean>;
  /** ブロックID → サムネイルdata URL。無いブロックは色見本で代用する。 */
  thumbnails: Map<string, string>;
  /** 未チェックのカードを振って気づかせる合図。 */
  nudge: boolean;
  onToggle: (block: string) => void;
}

/** じゅんび画面の「きょう つかう ブロック」。カードをタップして集めたチェックを付ける。 */
export function ItemChecklist({ items, checks, thumbnails, nudge, onToggle }: ItemChecklistProps) {
  return (
    <ul className="guide-items">
      {items.map((item) => {
        const checked = checks[item.block] === true;
        const thumbnail = thumbnails.get(item.block);
        return (
          <li key={item.block}>
            <button
              type="button"
              className={`guide-item${checked ? ' is-checked' : ''}${nudge && !checked ? ' is-nudged' : ''}`}
              aria-pressed={checked}
              onClick={() => onToggle(item.block)}
            >
              {checked && <span className="guide-item-badge" aria-hidden="true">✓</span>}
              {thumbnail
                ? <img src={thumbnail} alt="" width={44} height={44} />
                : <span className="guide-item-swatch" style={{ background: `#${blockColor(item.block).toString(16).padStart(6, '0')}` }} />}
              <span className="guide-item-name"><RubyText text={item.label ?? blockLabel(item.block)} /></span>
              <span className="guide-item-count">×{item.count}</span>
              <InventoryHint block={item.block} compact />
              {item.note && <span className="guide-item-note"><RubyText text={item.note} /></span>}
            </button>
            <InventoryMapButton block={item.block} />
          </li>
        );
      })}
    </ul>
  );
}
